import { render } from "./CardPayment.vue?vue&type=template&id=f85ab66e"
import script from "./CardPayment.vue?vue&type=script&lang=js"
export * from "./CardPayment.vue?vue&type=script&lang=js"

import "./CardPayment.vue?vue&type=style&index=0&id=f85ab66e&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__